import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from './shared/base-api-template-service.model';
import {Core2Config} from './shared/core2Config';
import {BaseContainerModel} from '../../../../models/aggregates/base-container.model';

// TODO put in the right place
export class GeneralReportDtoModel {
  reportParameters: any;
}


@Injectable({providedIn: 'root'})
export class Reports2Service extends BaseApiTemplateService<GeneralReportDtoModel> {

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + 'core1/reports-2';
    this.endpoint_path = 'core1/reports-2';
    this.httpClient = theHttp;
  }

}
